import { EmptyEx } from "components/_extensions/react-admin/ra-ui-materialui/src/list/EmptyEx";
import { ImportDialogButton } from "components/dialogs/ImportDialog/ImportDialogButton";
import React from "react";
import { useListContext } from "react-admin";

import { AddProductArticle } from "./AddProductArticle";

export const EmptyProductArticles = ({ companyId }) => {
	const { refetch } = useListContext();

	return (
		<EmptyEx
			customActions={
				<>
					<ImportDialogButton
						label="osfc.buttons.import"
						dialogTitle="osfc.dialogs.product-articles-import-upload.title"
						uploadEndpoint="product-articles-upload"
						successMessage="osfc.dialogs.product-articles-import-upload.success"
						onSuccess={refetch}
						initialValues={{ company_id: companyId }}
						acceptTypes=".xlsx"
					/>
					<AddProductArticle companyId={companyId} isNeedRefresh={false} onCreated={refetch} />
				</>
			}
			resource="product-articles"
		/>
	);
};
